// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-admin-home-page{
    margin: 0px;
    padding: 0px;
    height: 100vh;
    box-sizing: border-box;
    font-family:Verdana, Geneva, Tahoma, sans-serif;
}
.tenant-admin-home-page-layout{
    height: 90%;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: auto 1fr;
}
.tenant-admin-home-page-parent-container{
    display: flex;
    align-items: center;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/HomePage/HomePage.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,+CAA+C;AACnD;AACA;IACI,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B","sourcesContent":[".tenant-admin-home-page{\r\n    margin: 0px;\r\n    padding: 0px;\r\n    height: 100vh;\r\n    box-sizing: border-box;\r\n    font-family:Verdana, Geneva, Tahoma, sans-serif;\r\n}\r\n.tenant-admin-home-page-layout{\r\n    height: 90%;\r\n    box-sizing: border-box;\r\n    display: grid;\r\n    grid-template-columns: auto 1fr;\r\n}\r\n.tenant-admin-home-page-parent-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
